import { combineReducers } from 'redux';
import CompaniesReducer from './CompaniesReducer';
import WorkersReducer from './WorkersReducer';
import BudgetGroupsReducer from './BudgetGroupsReducer';
import BudgetLoadReducer from './BudgetLoadReducer';
import PaymentOptionsReducer from './PaymentOptionsReducer';
import MonthlyBudgetBreakdownReducer from './MonthlyBudgetBreakdownReducer';
import OrdersReducer from './OrdersReducer';
import ReportsReducer from './ReportsReducer';

export default combineReducers({
    companies: CompaniesReducer,
    workers: WorkersReducer,
    budgetGroups: BudgetGroupsReducer,
    budgetLoad: BudgetLoadReducer,
    paymentOptions: PaymentOptionsReducer,
    monthlyBreakdown: MonthlyBudgetBreakdownReducer,
    orders: OrdersReducer,
    reports: ReportsReducer,
});
